import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
declare var External: any;
declare var $: any;

@Component({
	selector: 'app-left-nav',
	templateUrl: './left-nav.component.html',
	styleUrls: ['./left-nav.component.css']
})
export class LeftNavComponent implements OnInit {
	
	is_super_admin:boolean= false;

	constructor(
		private commonService: CommonService,
		 private router: Router
	) {
		this.is_super_admin = JSON.parse(localStorage.getItem('is_super_admin'));
		console.log(this.is_super_admin);
	}

	selected_menus = '';
	ngOnInit() {
		let obj = this;
		setTimeout(function () {
			obj.selected_menus = obj.router.url.replace('/', '');
		}, 500);
	}
	activateMenu(val) {
		this.selected_menus = val;
		External.loadSubMenu();
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/left-nav/left-nav.component.ts